<template>
  <horizontally-scrollable-container>
    <table
      class="ui celled large striped compact unstackable table">
      <thead>
        <tr>
          <th class="fitted">
            {{ $t('medgateId') }}
          </th>
          <th>{{ $t('name') }}</th>
          <th>{{ $t('patientInfo.progress') }}</th>
          <th>{{ $t('patientInfo.lastFeedbackDate') }}</th>
          <th>{{ $t('patientInfo.doctorAppt') }}</th>
          <th>{{ $t('patientInfo.coachAppt') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          :key="patient.id"
          v-for="patient in patients">
          <td>
            <router-link :to="{ name: 'PatientMonitoring', params: { patientId: patient.id } }">
            <!-- NOTE: Deprecated in Migraine Care 2.0 -->
            <!-- <router-link :to="{ name: 'PatientFeedbackAndMonitoring', params: { patientId: patient.id } }"> -->
              {{ patient.externalId }}
              <i class="chevron right icon"/>
            </router-link>
          </td>
          <td>{{ patient.name }}</td>
          <td>
            <template v-if="!patient.data.startDate">
              {{ $t('patientInfo.unknown') }}
            </template>
            <template v-else-if="patient.data.startDate > Date.now()">
              {{ $t('patientInfo.notYetStarted') }}
            </template>
            <template v-else>
              {{ $tc('day') }} {{ calculateCoachingDay(patient.data.startDate) }}
            </template>
          </td>
          <td>
            <template v-if="patient.data.coachMessage && patient.data.coachMessage.lastModifiedTime">
              {{ $d(patient.data.coachMessage.lastModifiedTime, 'short') }}
            </template>
            <template v-else>
              {{ $t('patientInfo.notSet') }}
            </template>
          </td>
          <td>
            <router-link
              :to="{ name: 'PatientAppointments', params: { patientId: patient.id } }"
              class="ui circular icon mini button">
              <i class="calendar plus outline icon"/>
            </router-link>
            <!-- FIXME: To be restore when backend can supply latest appointment -->
            <!-- <template v-if="patient.data.docAppt && patient.data.docAppt.timestamp">-->
            <!--   {{ $d(patient.data.docAppt.timestamp, 'short') }}-->
            <!-- </template>-->
            <!-- <template v-else>-->
            <!--   {{ $t('patientInfo.notSet') }}-->
            <!-- </template>-->
          </td>
          <td>
            <router-link
              :to="{ name: 'PatientAppointments', params: { patientId: patient.id } }"
              class="ui circular icon mini button">
              <i class="calendar plus outline icon"/>
            </router-link>
            <!-- FIXME: To be restore when backend can supply latest appointment -->
            <!--<template v-if="patient.data.coachAppt && patient.data.coachAppt.timestamp">-->
            <!--  {{ $d(patient.data.coachAppt.timestamp, 'short') }}-->
            <!--</template>-->
            <!--<template v-else>-->
            <!--  {{ $t('patientInfo.notSet') }}-->
            <!--</template>-->
          </td>
        </tr>
      </tbody>
    </table>
  </horizontally-scrollable-container>
</template>

<script>
import HorizontallyScrollableContainer from '../utility/HorizontallyScrollableContainer'
export default {
  name: 'PatientsTable',
  components: { HorizontallyScrollableContainer },
  props: {
    patients: {
      type: Array,
      required: true
    }
  },
  methods: {
    calculateCoachingDay (startDate) {
      return Math.floor((Date.now() - startDate) / 86400000) + 1
    }
  }
}
</script>
